<template>
    <div>
        <div class="module_addi">
            <div class="btn_outer">
                <el-button type="success" @click="downloadFile(templatefile[0].file_name,templatefile[0].name)" plain>
                    <i class="cloudicon ci_download"></i>离奉登记表格下载
                </el-button>
            </div>
            <div class="fill_i">
                <span class="txt">填报前，请先阅读填报格式说明</span>
                <div class="btn_outer">
                    <el-button type="danger" @click="downloadFile(Gssmfile[0].file_name,Gssmfile[0].name)" plain>
                        <i class="cloudicon ci_download"></i>填报格式说明下载
                    </el-button>
                </div>
            </div>
            
        </div>

        <div class="user_module">
            <div class="module_head">
                <div>离奉人员登记</div>
            </div>
            <div class="module_tab_cont comeleave">
                <el-table :data="tablelist" stripe  style="width: 100%">
                    <el-table-column prop="name" label="文件名称" width="320px"></el-table-column>
                    <el-table-column prop="create_date" label="上传时间"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="200">
				        <template slot-scope="scope">
				          <div class="btn_outer">
                              <el-button @click="downloadFile(tablelist[0].file_name,tablelist[0].name)" type="success" plain size="small">下载</el-button>
				          	    <el-upload
                                    class="upload-demo"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :http-request="htrupl"
                                    style="display:inline-block"
                                >
                                    <el-button size="small" plain type="primary">上传更新</el-button>
                                </el-upload>
                          </div>
				        </template>
				  </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import Qs from 'qs'
export default {
    inject:['reload'],
    data(){
        return {
            Gssmfile: [{"name":"离奉人员登记表填写说明.xlsx","is_out":"1","file_name": this.bUrl + "upload/default/离奉人员登记表填写说明.xlsx"}],
            templatefile: [{"name":"工业综合开发区离奉人员登记表.xlsx","is_out":"1","file_name": this.bUrl + "upload/default/工业综合开发区离奉人员登记表.xlsx"}],
            tablelist: [{"id":9,"name":"工业综合开发区离奉人员登记表.xlsx","create_date":"2020-09-21 08:00:00","is_out":"1","file_name": this.bUrl + "upload/default/工业综合开发区离奉人员登记表.xlsx"}]
        }
    },
    created(){
        this.getLeaveList()
    },
    methods:{
        async getLeaveList() {
            let res = await this.$ajax.get(this.bUrl + 'api/portal/outin/index?is_out=1');
            if(res.data.code!==200){
                this.$message.error(res.data.msg);
            }else {
                let _list = res.data.data.list
                if(_list.length==1){
                    _list[0].create_date = _list[0].create_date.replace('+08','').replace('+00','');
                    this.tablelist = _list;
                }
            }
        },
        update(id){
            var data = Qs.stringify({'is_out':1,'data_id':id});
			this.$ajax.post(this.bUrl+'api/portal/outin/add',data)
			.then(function(res) {
                if(res.data.code!=200){
                    this.$message.error(res.data.msg);
                }else{
                    this.$message.success('上传更新成功');
                    this.reload()
                }
			}.bind(this))
			.catch(function(error) {
				console.log(error);
			});
        },
        htrupl(param) {
            let fileName = param.file.name.lastIndexOf(".");
            let fileNameLength = param.file.name.length;
            let fileFormat = param.file.name.substring(fileName + 1, fileNameLength);
            if(fileFormat!='xlsx'){
              this.$message.warning('只可上传excel电子表格')
              return
            }
            const formData = new FormData()
            formData.append('file', param.file);
            this.$ajax.post(this.bUrl + 'api/portal/user/webuploader?_ajax=1&filetype=file', formData)
            .then(function (res) {
                if (res.data.code == 200) {
                    this.$message.success(res.data.msg);
                    this.update(res.data.data.id)
                } else {
                    this.$message.error(res.data.msg)
                }
            }.bind(this))
            .catch(function (error) {
                console.log(error);
            });
        },
        downloadFile(url, name){
            url = url.replace('http://','https://')
            this.$down.download (url, name)
        }
    }
}
</script>
<style scoped>
    .user_module {
        width: 100%;
        box-sizing: border-box;
        padding: 25px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
        border: 1px solid #E1EAFA;
        margin-bottom: 20px;
    }
    .module_addi {
        width: 100%;
        margin: 10px 0 30px 0;
        display: flex;
        justify-content: space-between;
    }
    .fill_i{
        display: inline-flex;
        align-items: center;
        color:#f56c6c;
    }
    .fill_i .txt{
        margin-right: 20px;
        font-size: 13px;
    }
</style>



// WEBPACK FOOTER //
// src/components/user/leaveFX.vue